import type { Conversation } from "../../types/conversation";
import { ConversationHeader } from "../conversation/header";
import { MessageList } from "../conversation/message-list";

interface Props {
  isOpen: boolean;
  conversation: Conversation | null;
  onClose: () => void;
}

export function ViewConversationModal({
  isOpen,
  conversation,
  onClose,
}: Props) {
  if (!isOpen || !conversation) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="w-[90vw] min-h-0 rounded-2xl border border-slate-200 bg-white shadow-2xl md:w-full md:max-w-[30vw]"
        style={{
          height: `70vh`,
          display: `flex`,
          flexDirection: `column`,
          overflow: `hidden`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-end p-3 border-b">
          <button
            onClick={onClose}
            className="btn btn-secondary cursor-pointer"
          >
            Fechar
          </button>
        </div>

        <ConversationHeader conversation={conversation} />

        <div className="flex-1 min-h-0 px-3 flex flex-col">
          <MessageList messages={conversation.messages} />
        </div>
      </div>
    </div>
  );
}
